'use strict';

var Utils = require('../../utils/utils');

var Scrolled = function(config) {
  var self = this;
  var $window = $(window);
  var $header = $(config.header);
  var scrollDistance = $header.innerHeight();
  var $brandComplete = $(config.brandComplete);
  var $brandShort = $(config.brandShort);
  var scrollStyleDelay = false;

  self.headerScrolledStyle = function() {
    var st = $window.scrollTop();
    var delay = scrollStyleDelay ? 300 : 0
    if (st > scrollDistance) {
      setTimeout(function () {
        $header.addClass('-scrolled');
      }, delay);
    } else {
      setTimeout(function () {
        $header.removeClass('-scrolled');
      }, delay);
    }
  }

  self.brandVisibility = function() {
    var st = $window.scrollTop();
    if (st > scrollDistance) {
      self.hideCompleteBrand();
    } else {
      self.showCompleteBrand();
    }
  }

  self.hideCompleteBrand = function() {
    if (!$brandComplete.hasClass('is-hidden') && !$brandComplete.hasClass('velocity-animating')) {
      $brandComplete
        .velocity('stop')
        .velocity(
        'fadeOut', {
          duration: 300,
          complete: function() {
            if (!$brandShort.hasClass('is-visible') && !$brandShort.hasClass('velocity-animating')) {
              $brandShort
                .velocity('fadeIn', {
                  duration: 300
                })
                .addClass('is-visible');
            }
          }
        })
        .addClass('is-hidden');
    }
  }

  self.showCompleteBrand = function() {
    if ($brandComplete.hasClass('is-hidden') && !$brandComplete.hasClass('velocity-animating')) {
      $brandShort
        .velocity('stop')
        .velocity(
        'fadeOut', {
          duration: 300,
          complete: function() {
            $brandComplete
              .velocity('fadeIn', {
                duration: 300
              })
              .removeClass('is-hidden');
          }
        })
        .removeClass('is-visible');
    }
  }

  self.scrollListeners = function() {
    var mobileViewports = function() {
      scrollStyleDelay = false;
      $brandComplete.removeAttr('style');
      $brandShort.removeAttr('style');
      $window.off('scroll.brandVisibility');
    };
    var smallViewports = function() {
      scrollStyleDelay = true;
      $brandComplete.removeAttr('style');
      $brandShort.removeAttr('style');
      self.brandVisibility();
      $window.on('scroll.brandVisibility', new Utils().throttle(self.brandVisibility, 60));
    };
    new Utils().matchmediaHandler('SMALL', smallViewports, mobileViewports);
    $window.on('scroll.headerScrolledStyle', new Utils().throttle(self.headerScrolledStyle, 60));
  }

  self.init = function() {
    self.headerScrolledStyle();
    self.scrollListeners();
  }
};

module.exports = Scrolled;
